// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login/Login";
import TableViewer from "./pages/Tables/Tables";
import { useAuth } from "./context/AuthContext";
import { TableListProvider } from "./context/TableListContext";
import Home from "./pages/Home/Home"; 
import Profile from "./pages/Profile/Profile";
import ActivityLog from "./pages/ActivityLog/ActivityLog";
import Insights from "./pages/Insights/Insights";
import QuickStart from "./pages/QuickStart/QuickStart";


function App() {
  const { currentUser } = useAuth();

  return (
    <Router>
      <TableListProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Single page that covers ALL tables */}
          <Route
            path="/tables"
            element={currentUser ? <TableViewer /> : <Navigate to="/login" />}
          />

          <Route
            path="/home"
            element={currentUser ? <Home /> : <Navigate to="/login" />}
          />
          <Route
            path="/profile"
            element={currentUser ? <Profile /> : <Navigate to="/login" />}
          />
          <Route
            path="/activity-log"
            element={currentUser ? <ActivityLog /> : <Navigate to="/login" />}
          />
          <Route
            path="/insights"
            element={currentUser ? <Insights /> : <Navigate to="/login" />}
          />
          <Route
            path="/quick-start"
            element={currentUser ? <QuickStart /> : <Navigate to="/login" />}
          />
          {/* You can keep these or drop them if TableViewer replaces them */}
          <Route
            path="/"
            element={
              currentUser ? <Navigate to="/home" /> : <Navigate to="/login" />
            }
          />
        </Routes>
      </TableListProvider>
    </Router>
  );
}

export default App;
